<div class="page--building-level-real-estate-transactions-page--market-data-overview-desktop--bar-chart-tooltip-point-content">
    <div style="color: <%= symbol_color %>; margin-right: 4px;"> &#9644 </div>
    <div class="page--building-level-real-estate-transactions-page--market-data-overview-desktop--bar-chart-tooltip-point-content-label">
        <%= label %>:
    </div>
    <div class="page--building-level-real-estate-transactions-page--market-data-overview-desktop--bar-chart-tooltip-point-content-value">
        <%= y %>
    </div>
</div>
